import React, { memo, ReactElement } from 'react'
import { Field } from 'redux-form'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { Checkbox } from 'antd'

import CheckboxField from 'shared/components/fields/CheckboxField'

import { getManagePermissions, getViewPermissions } from './Permissions.helpers'
import { PermissionGroupProps } from './Permissions.model'
import styles from './Permissions.module.scss'
import { ApplicationPermissionMap } from 'core/selectors/Profile.selectors'
import { getManagerPermissionGroupName } from 'shared/helpers/utils'

const PermissionGroup = memo(function (
  props: PermissionGroupProps
): ReactElement {
  const {groupPermissions, profilePermissions, isGroupChecked, isGroupIndeterminate, editingDisabled, currentPermisisons, currentAccessScope} = props
  const viewRole = getViewPermissions(profilePermissions)
  const manageRole = getManagePermissions(profilePermissions)
  const onGroupCheckboxChange = (event: CheckboxChangeEvent): void => {
    const newPermissions = groupPermissions.reduce((res, i) => ({ ...res, [i.id]: event.target.checked }), {})
    props.onGroupCheckboxChange(newPermissions)
  }

  return groupPermissions.length > 0 ? (
    <div key={props.groupName} className={styles.group}>
      <div className={styles.groupHeader}>
        <Checkbox
          className={styles.checkGroup}
          onChange={onGroupCheckboxChange}
          checked={isGroupChecked}
          indeterminate={isGroupIndeterminate}
          disabled={!editingDisabled}
        >
          <p className={styles.subGroup}>
            {getManagerPermissionGroupName(props.groupName, props.keylockerEnabled!)}
          </p>
        </Checkbox>
      </div>

      <div className={styles.checkboxesWrap}>
        {groupPermissions.map((permission) => {
          if (
            (currentAccessScope  &&
              permission.system_scope) ||
            (!currentAccessScope &&
              permission.account_scope)
          ) {
            const viewAmLicense = profilePermissions.find(perm => perm.name === ApplicationPermissionMap.canViewAMLicense)
            const manageAmLicense = profilePermissions.find(perm => perm.name === ApplicationPermissionMap.canManageAMLicense)
            const viewLicensePermission = viewRole.find(perm => perm.id === permission.id)
            const manageLicensePermission = manageRole.find(perm => perm.id === permission.id)
            let perm
            if (currentPermisisons) {
              if(viewLicensePermission && viewAmLicense && currentPermisisons[viewAmLicense.id]) {
                perm = currentPermisisons[viewLicensePermission.id]
              }
              if (manageLicensePermission && manageAmLicense && currentPermisisons[manageAmLicense.id]) {
                perm = currentPermisisons[manageLicensePermission.id]
              }
            }
            return (
              <div className={styles.fieldWrap} key={permission.id}>
                <Field
                  name={permission.id}
                  label={`permissions.${permission.name}`}
                  component={CheckboxField}
                  licensePerm = {perm}
                  disabled={!props.editingDisabled}
                  infoSection={viewAmLicense && viewAmLicense.id === permission.id || manageAmLicense && manageAmLicense.id === permission.id}
                />
              </div>
            )
          }
          return null
        })}
      </div>
    </div>
  ) : (
    <></>
  )
})

PermissionGroup.displayName = 'PermissionGroup'

export default PermissionGroup
